"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFuzzy = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_use_1 = require("react-use");
var fuzzy_search_1 = require("./fuzzy-search");
function useFuzzy(data, options) {
    var _a = options.debounce, debounce = _a === void 0 ? 0 : _a, fuzzyOptions = (0, tslib_1.__rest)(options, ["debounce"]);
    var _b = react_1.default.useState(''), query = _b[0], setQuery = _b[1];
    var _c = (0, react_1.useState)(''), debouncedQuery = _c[0], setDebouncedQuery = _c[1];
    (0, react_use_1.useDebounce)(function () {
        setDebouncedQuery(query);
    }, debounce, [query, setDebouncedQuery]);
    var results = (0, fuzzy_search_1.fuzzySearch)(data, debouncedQuery, fuzzyOptions);
    return {
        query: query,
        debouncedQuery: debouncedQuery,
        results: results,
        search: setQuery,
    };
}
exports.useFuzzy = useFuzzy;
//# sourceMappingURL=use-fuzzy.js.map